import { ChevronRight } from 'lucide-react'

import { type EmployersMemberInvoiceDetail, type Money } from 'utils/web_api.schemas'

interface MemberInvoiceBreakdownMobileProps {
  memberInvoices: EmployersMemberInvoiceDetail[]
  priorMonthName: string
  nextMonthName: string
  formatMoneyValue: (money: Money | undefined) => string
  showPlanYear: boolean
  onMemberClick: (memberInvoiceId: string) => void
}

export function MemberInvoiceBreakdownMobile ({
  memberInvoices,
  priorMonthName,
  nextMonthName,
  formatMoneyValue,
  showPlanYear,
  onMemberClick,
}: MemberInvoiceBreakdownMobileProps) {
  return (
    <div className='mt-4 md:hidden space-y-0'>
      {memberInvoices.map((memberInvoice, index) => (
        <div
          key={memberInvoice.id}
          onClick={() => onMemberClick(memberInvoice.id)}
          className='cursor-pointer'
        >
          {index > 0 && <hr className='border-gray-200 my-4' />}
          <div className='flex items-center mb-3'>
            <span className='body flex items-center'>{memberInvoice.full_name || '---'}</span>
            <div className='grow shrink-0 min-w-4 mx-2 flex items-center'>
              <svg className='w-full' height='4' style={{ overflow: 'visible' }}>
                <line
                  x1='0'
                  y1='2'
                  x2='100%'
                  y2='2'
                  stroke='#CFCFCF'
                  strokeWidth='3'
                  strokeLinecap='round'
                  strokeDasharray='0 12'
                />
              </svg>
            </div>
            <div className='flex items-center gap-2'>
              <span className='body text-right'>{formatMoneyValue(memberInvoice.amounts?.total)}</span>
              <ChevronRight size={16} className='text-gray-400' />
            </div>
          </div>
          <div className='space-y-2'>
            {showPlanYear && (
              <div className='flex justify-between items-center'>
                <span className='body-sm text-gray-500'>Plan Year</span>
                <span className='body-sm text-right mr-2'>
                  {memberInvoice.plan_year ?? '---'}
                </span>
              </div>
            )}
            <div className='flex justify-between items-center'>
              <span className='body-sm text-gray-500'>
                Payment for {priorMonthName} insurance coverage
              </span>
              <span className='body-sm text-right mr-2'>
                {formatMoneyValue(memberInvoice.amounts?.premiums)}
              </span>
            </div>
            <div className='flex justify-between items-center'>
              <span className='body-sm text-gray-500'>
                Pre-payment for {nextMonthName} insurance coverage
              </span>
              <span className='body-sm text-right mr-2'>
                {formatMoneyValue(memberInvoice.amounts?.total_insurance_premiums)}
              </span>
            </div>
            <div className='flex justify-between items-center'>
              <span className='body-sm text-gray-500'>Qualified medical expenses</span>
              <span className='body-sm text-right mr-2'>
                {formatMoneyValue(memberInvoice.amounts?.other)}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
